module.exports = __webpack_public_path__ + "static/media/equip.540e03ee.svg";